import {Component, signal, WritableSignal} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {MatIcon} from "@angular/material/icon";
import {EsvgFiles} from "frontier";

@Component({
  selector: 'app-cell-renderer-icon',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './cell-renderer-icon.component.html',
  styleUrl: './cell-renderer-icon.component.scss'
})
export class CellRendererIconComponent implements ICellRendererAngularComp {
  public params: any;
  icon: WritableSignal<EsvgFiles.correct | EsvgFiles.warning> = signal<EsvgFiles.correct | EsvgFiles.warning>(null);

  agInit(params: any): void {
    this.updateParams(params);
  }

  refresh(params: any): boolean {
    this.updateParams(params);
    return true;
  }

  updateParams(params: any): void {
    this.params = params;
    if (this.params.data?.label === 'Prüfung') {
      this.icon.set(this.params.data.value === '' ? EsvgFiles.correct : EsvgFiles.warning);
    }
  }

  protected readonly EsvgFiles = EsvgFiles;
}
